import React, { useState, useEffect, useRef } from 'react';

const Skills = () => {
    const [showSkills, setShowSkills] = useState(false);
    const skillsRef = useRef(null);
    const languages = [
        { logo: 'https://img.icons8.com/color/480/html-5--v1.png' },
        { logo: 'https://img.icons8.com/color/480/css3.png' },
        { logo: 'https://img.icons8.com/color/480/javascript--v1.png' },
        { logo: 'https://img.icons8.com/officel/480/react.png' },
        { logo: 'https://img.icons8.com/color/480/nodejs.png' },
        { logo: 'https://img.icons8.com/officel/480/express-js.png' },
        { logo: 'https://img.icons8.com/nolan/64/mongo-db.png' },
    ];

    const handleScroll = () => {
        const skillsPosition = skillsRef.current.getBoundingClientRect().top;
        const screenHeight = window.innerHeight;
        if (skillsPosition < screenHeight) {
            setShowSkills(true);
            // Remove scroll listener once skills are shown
            window.removeEventListener('scroll', handleScroll);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        // Clean up the event listener on component unmount
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    });

    return (
        <>
            <div ref={skillsRef} className="skills-section" id='skills'>
                <h2 className='skill color'>Skills</h2>
                {showSkills && (
                    <div className="skills-list">
                        {languages.map((language, index) => (
                            <div key={index} className="skill-item" style={{ animationDelay: `${index * 0.5}s` }} >
                                <img src={language.logo} alt={'skills'} />
                            </div>
                        ))}
                    </div>
                )}
            </div>
            <hr className='skills_end' />
        </>
    );
};

export default Skills;